import { render, staticRenderFns } from "./DocumentosTransferCreator.vue?vue&type=template&id=973bac42&scoped=true"
import script from "./DocumentosTransferCreator.vue?vue&type=script&lang=js"
export * from "./DocumentosTransferCreator.vue?vue&type=script&lang=js"
import style0 from "./DocumentosTransferCreator.vue?vue&type=style&index=0&id=973bac42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973bac42",
  null
  
)

export default component.exports